<template>
  <div>
    <base-header class="pb-6">
      <b-row align-v="center" class="py-4">
        <b-col lg="6" cols="7" >
          <h6 class="h2 text-white d-inline-block mb-0">
            <!-- {{$route.name}} -->
            </h6>
          <!-- <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-breadcrumb/>
          </nav> -->
        </b-col>
        <!-- <b-col lg="6" cols="5" class="text-right">
          <base-button size="sm" type="neutral">New</base-button>
          <base-button size="sm" type="neutral">Filters</base-button>
        </b-col> -->
      </b-row>
    </base-header>

    <b-container fluid class="mt--6"  style="margin-top:-38px !important">
      <b-row>
        <b-col lg="6">
          <card header-classes="bg-transparent">
            <h3 slot="header" class="mb-0">SwiftStorm 基于Transformer AI大模型训练的中短线趋势策略</h3>
            <p >
                <!-- 多头持仓：<font color="red">{{l_current_volume}}</font>&nbsp;
                空头持仓：<font color="green">{{s_current_volume}}</font>&nbsp; -->
                <span v-if="l_current_volume_count > 0">多头持仓：<font color="red">{{l_current_volume_count}}个 ({{l_current_volume}}手)</font>&nbsp;</span>
                 
                <span v-if="s_current_volume_count > 0">空头持仓：<font color="green">{{s_current_volume_count}}个 ({{s_current_volume}}手)</font>&nbsp;</span>
                   
                逐笔盈亏：
                <font v-if="float_porfit_o>=0" color="red">¥{{float_porfit_o_str}}</font>
                <font v-if="float_porfit_o<0" color="green">¥{{float_porfit_o_str}}</font>
                &nbsp;
                逐笔平仓盈亏：
                <font v-if="exit_float_porfit_o>=0" color="red">¥{{exit_float_porfit_o_str}}</font>
                <font v-if="exit_float_porfit_o<0" color="green">¥{{exit_float_porfit_o_str}}</font>
            </p>

            <p slot="header" style="margin-top:10px;margin-bottom:0px">
                投喂过去20年的期货、股市、汇率、新闻等数据，以及交易大师们的经典交易手法，进行模型训练和深度学习生成的交易策略；以下数据为AI结合实盘，实时计算的结果，仅作技术研究和分享，不构成任何投资建议。
            </p>

              <p v-if="!isVIP">
                <!-- <a style="margin-top:0px;color:red" href="/#/home/pricing">数据仅对会员开放，您需购买算力服务后即可正常显示策略信息，欢迎咨询购买。</a> -->
                <span style="margin-top:0px;color:red">数据仅对会员邀请开放，欢迎和我们联系免费获取。</span>
            </p>


          <el-table
              :data="tableData"
              :default-sort="{ prop: 'category', order: 'descending' }"
              row-key="id"
              header-row-class-name="thead-light"
              
            >
              <el-table-column
                v-for="column in tableColumns"
                :key="column.prop"
                v-bind="column"
              >
              </el-table-column>
              
            </el-table>
          </card>

           <card style="width:100%;margin-top:-10px">
                <!-- Card header -->
                <div slot="header" style="margin-bottom:-10px">

                    <b-col cols="12" class="d-flex justify-content-center justify-content-sm-between flex-wrap">
                        <div class="text-left">
                            <h3 class="mb-0">今日委托成交、今已平</h3>
                        </div>
                    </b-col>
                </div>

              <el-table
              :data="tableData1"
              :default-sort="{ prop: 'category', order: 'descending' }"
              row-key="contract"
              header-row-class-name="thead-light"
              
            >
              <el-table-column
                v-for="column in tableColumns1"
                :key="column.prop"
                v-bind="column"
              >
              </el-table-column>
              
            </el-table>
              </card>

              <card style="width:100%;margin-top:-10px">
                <div slot="header" style="margin-bottom:-10px">

                    <b-col cols="12" class="d-flex justify-content-center justify-content-sm-between flex-wrap">
                        <div class="text-left">
                            <h3 class="mb-0">资金曲线</h3>
                        </div>
                    </b-col>
                </div>

             <line-chart
              :height="350"
              ref="bigChart"
              :chart-data="bigLineChart.chartData"
              :extra-options="bigLineChart.extraOptions"
            >
            </line-chart>
              </card>
        </b-col>
        <b-col lg="6">
           <card header-classes="bg-transparent">
            <!-- <h3 slot="header" class="mb-0">SwiftStorm 基于Transformer AI大模型训练的中短线趋势策略</h3> -->
            <h3 slot="header" class="mb-0">EverSteady 基于Transformer AI大模型训练的中长线趋势策略</h3>
             <p >
                <span v-if="l_current_volume_count_1 > 0">多头持仓：<font color="red">{{l_current_volume_count_1}}个 ({{l_current_volume_1}}手)</font>&nbsp;</span>
                 
                <span v-if="s_current_volume_count_1 > 0">空头持仓：<font color="green">{{s_current_volume_count_1}}个 ({{s_current_volume_1}}手)</font>&nbsp;</span>
                   
                逐笔盈亏：
                <font v-if="float_porfit_o_1>=0" color="red">¥{{float_porfit_o_str_1}}</font>
                <font v-if="float_porfit_o_1<0" color="green">¥{{float_porfit_o_str_1}}</font>
                &nbsp;
                逐笔平仓盈亏：
                <font v-if="exit_float_porfit_o_1>=0" color="red">¥{{exit_float_porfit_o_str_1}}</font>
                <font v-if="exit_float_porfit_o_1<0" color="green">¥{{exit_float_porfit_o_str_1}}</font>
            </p>

            <p slot="header" style="margin-top:10px;margin-bottom:0px">
                底层框架在美股等海外市场实盘5年以上且表现优异，并将架构导入AI大模型，投喂过去20年的期货、股市、汇率、新闻等数据，进行模型训练和深度学习；以下数据为AI结合实盘，实时计算的结果，仅作技术研究和分享，不构成任何投资建议。
            </p>

            <p v-if="!isVIP">
                <!-- <a style="margin-top:0px;color:red" href="/#/home/pricing">数据仅对会员开放，您需购买算力服务后即可正常显示策略信息，欢迎咨询购买。</a> -->
                <span style="margin-top:0px;color:red">数据仅对会员邀请开放，欢迎和我们联系免费获取。</span>
            </p>
            
            <el-table
              :data="tableData_1"
              :default-sort="{ prop: 'category', order: 'descending' }"
              row-key="id"
              header-row-class-name="thead-light"
              
            >
              <el-table-column
                v-for="column in tableColumns_1"
                :key="column.prop"
                v-bind="column"
              >
              </el-table-column>
              
            </el-table>

          </card>

   <card style="width:100%;margin-top:-10px">
                <!-- Card header -->
                <div slot="header" style="margin-bottom:-10px">

                    <b-col cols="12" class="d-flex justify-content-center justify-content-sm-between flex-wrap">
                        <div class="text-left">
                            <h3 class="mb-0">今日委托成交、今已平</h3>
                        </div>
                    </b-col>
                </div>

              <el-table
              :data="tableData1_1"
              :default-sort="{ prop: 'category', order: 'descending' }"
              row-key="contract"
              header-row-class-name="thead-light"
              
            >
              <el-table-column
                v-for="column in tableColumns1_1"
                :key="column.prop"
                v-bind="column"
              >
              </el-table-column>
              
            </el-table>
              </card>

              <card style="width:100%;margin-top:-10px">
                <div slot="header" style="margin-bottom:-10px">

                    <b-col cols="12" class="d-flex justify-content-center justify-content-sm-between flex-wrap">
                        <div class="text-left">
                            <h3 class="mb-0">资金曲线</h3>
                        </div>
                    </b-col>
                </div>

             <line-chart
              :height="350"
              ref="bigChart"
              :chart-data="bigLineChart1.chartData"
              :extra-options="bigLineChart1.extraOptions"
            >
            </line-chart>
              </card>

        </b-col>
      </b-row>
    </b-container>

  </div>
</template>
<script>
  import * as chartConfigs from "@/components/Charts/config";
  import { TimeLine, TimeLineItem } from '@/components';
  import RouteBreadcrumb from '@/components/Breadcrumb/RouteBreadcrumb';
  import BaseHeader from '@/components/BaseHeader';
  import Badge from '@/components/Badge';
  import { Table, TableColumn, Select, Option } from "element-ui";
  import futureApi from "../../api/future";
  import PriceLabel from "../LinearSwap/priceLabel";
  import LineChart from "@/components/Charts/LineChart";
var moment = require("moment");
const numeral = require('numeral');
  export default {
    components: {
        [Select.name]: Select,
        [Option.name]: Option,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        LineChart,
        PriceLabel,
      Badge,
      BaseHeader,
      TimeLine,
      TimeLineItem,
      RouteBreadcrumb
    },
      data() {
        return {
        isVIP:true,
        isVIP_1:true,
        checkAndPlayerSoundId:0,
        category:"",
        categoies:{},
        l_current_volume:0,
        s_current_volume:0,

        l_current_volume_count:0,
        s_current_volume_count:0,


        float_porfit_o:0,
        float_porfit_o_str:"0",
        exit_float_porfit_o:0,
        exit_float_porfit_o_str:"0",


        l_current_volume_count_1:0,
        s_current_volume_count_1:0,
        l_current_volume_1:0,
        s_current_volume_1:0,
        float_porfit_o_1:0,
        float_porfit_o_str_1:"0",
        exit_float_porfit_o_1:0,
        exit_float_porfit_o_str_1:"0",


        propsToSearch: ["code"],
        tableColumns1:[
            {
                prop: "category_name",
                label: "分类",
                minWidth: 100,
                sortable: false,
            },
            {
                prop: "name",
                label: "名称",
                minWidth: 120,
                sortable: false,
            },
            {
                prop: "code",
                label: "合约",
                minWidth: 100,
                sortable: false,
                formatter: this.formatterContract,
            },
            {
                prop: "buy_sell",
                label: "买卖",
                minWidth: 70,
                sortable: false,
                formatter: this.formatterSignalBuySell,
            },
            {
                prop: "deal_type",
                label: "开平",
                minWidth: 70,
                sortable: false,
                formatter: this.formatterSignalDealType,
            },
            {
                prop: "lots",
                label: "成交数量",
                minWidth: 100,
                sortable: false,
            },
            {
                prop: "signal_porfit",
                label: "盈亏",
                minWidth: 150,
                sortable: false,
                formatter: this.formatterSignalWinLose,
            },
            {
                prop: "created_at",
                label: "时间",
                minWidth: 150,
                sortable: false,
                formatter: this.formatterDateTime,
            
            },

        ],
        tableColumns: [
            {
                prop: "category_name",
                label: "品种",
                minWidth: 100,
                sortable: true,
                formatter: this.formatterCategory,
            },
            // {
            //     prop: "name",
            //     label: "名称",
            //     minWidth: 120,
            //     sortable: true,
            // },
            {
                prop: "contract",
                label: "合约",
                minWidth: 100,
                sortable: true,
                formatter: this.formatterContract,
            },
            {
                prop: "l_current_volume",
                label: "净持仓",
                minWidth: 80,
                sortable: true,
                formatter: this.formatterCurrentVolume,
            },
            {
                prop: "l_avg_price_o",
                label: "逐笔均价",
                minWidth: 120,
                sortable: false,
                formatter: this.formatterAvgPrice,
            },
            {
                prop: "float_profit_o",
                label: "逐笔盈亏",
                minWidth: 120,
                sortable: true,
                formatter: this.formatterPriceWinLose,
            }

        ],
        tableData: [],
        tableData1: [],

        bigLineChart: {
            allData: [[0, 0, 0, 0, 0, 0, 0]],
            activeIndex: 0,
            extraOptions: chartConfigs.blueChartOptions,
            chartData: {
            datasets: [
                {
                label: "Performance",
                data: [0, 20, 10, 30, 15, 40, 20, 60, 60],
                },
            ],
            labels: ["May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
            },
        },


        propsToSearch_1: ["code"],
        tableColumns1_1:[
            {
                prop: "category_name",
                label: "分类",
                minWidth: 100,
                sortable: false,
            },
            {
                prop: "name",
                label: "名称",
                minWidth: 120,
                sortable: false,
            },
            {
                prop: "code",
                label: "合约",
                minWidth: 100,
                sortable: false,
                formatter: this.formatterContract_1,
            },
            {
                prop: "buy_sell",
                label: "买卖",
                minWidth: 70,
                sortable: false,
                formatter: this.formatterSignalBuySell_1,
            },
            {
                prop: "deal_type",
                label: "开平",
                minWidth: 70,
                sortable: false,
                formatter: this.formatterSignalDealType_1,
            },
            {
                prop: "lots",
                label: "成交数量",
                minWidth: 100,
                sortable: false,
            },
            {
                prop: "signal_porfit",
                label: "盈亏",
                minWidth: 150,
                sortable: false,
                formatter: this.formatterSignalWinLose_1,
            },
            {
                prop: "created_at",
                label: "时间",
                minWidth: 150,
                sortable: false,
                formatter: this.formatterDateTime,
            
            },
           

        ],
        tableColumns_1: [
            {
                prop: "category_name",
                label: "品种",
                minWidth: 100,
                sortable: true,
                formatter: this.formatterCategory,
            },
            // {
            //     prop: "name",
            //     label: "名称",
            //     minWidth: 120,
            //     sortable: true,
            // },
            {
                prop: "contract",
                label: "合约",
                minWidth: 100,
                sortable: true,
                formatter: this.formatterContract_1,
            },
            {
                prop: "l_current_volume",
                label: "净持仓",
                minWidth: 80,
                sortable: true,
                formatter: this.formatterCurrentVolume_1,
            },
            {
                prop: "l_avg_price_o",
                label: "逐笔均价",
                minWidth: 120,
                sortable: false,
                formatter: this.formatterAvgPrice,
            },
            {
                prop: "float_profit_o",
                label: "逐笔盈亏",
                minWidth: 120,
                sortable: true,
                formatter: this.formatterPriceWinLose_1,
            }

        ],
        tableData_1: [],
        tableData1_1: [],

        bigLineChart1: {
            allData: [[0, 0, 0, 0, 0, 0, 0]],
            activeIndex: 0,
            extraOptions: chartConfigs.blueChartOptions,
            chartData: {
            datasets: [
                {
                label: "Performance",
                data: [0, 20, 10, 30, 15, 40, 20, 60, 60],
                },
            ],
            labels: ["May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
            },
        },

        selectedRows: [],

        };
    },
    methods: {
        formatterContract(value, cloumn) {
            const str = value[cloumn.property];
            if(!str || str == "" || str == undefined)
            {
                return "";
            }
            // console.log("=======str:", str);
            const val = str.split(".");
            // console.log("=======val:", val[0]);
            return val[0];
        },
        formatterPriceWinLose(value, cloumn) {
            const l_current_volume = value["l_current_volume"];
            const s_current_volume = value["s_current_volume"];

            

            

            let float_profit_o = 0;
            if(l_current_volume > 0)
            {
                float_profit_o = parseFloat(value["l_float_porfit_o"]);
            }
            else if(s_current_volume > 0)
            {
                float_profit_o = parseFloat(value["s_float_porfit_o"]);
            }
        

            let priceClassName;
            if (float_profit_o > 0) {
                priceClassName = "text-danger";
            } else if (float_profit_o < 0) {
                priceClassName = "text-success";
            }

            let formattedNumber = numeral(float_profit_o).format('0,0.00');
            return this.$createElement("price-label", {
                props: { priceClassName, price: "¥" + formattedNumber },
            });

        },

        formatterSignalWinLose(value, cloumn) {

            let deal_type = value["deal_type"];
            if (deal_type == 'enterTrade') {
                return "-";
            }
            let float_profit_o = value["signal_porfit"];
            let priceClassName;
            if (float_profit_o > 0) {
                priceClassName = "text-danger";
            } else if (float_profit_o < 0) {
                priceClassName = "text-success";
            }

            let formattedNumber = numeral(float_profit_o).format('0,0.00');
            return this.$createElement("price-label", {
                props: { priceClassName, price: "¥" + formattedNumber },
            });

        },

        formatterSignalBuySell(value, cloumn) {

            if(!this.isVIP)
            {
                return "***"
            }

            let val = value["buy_sell"];
            let str = "";
            let priceClassName;
            if (val == 'buy') {
                priceClassName = "text-danger";
                str = "买入";
            } else if (val == 'sell') {
                priceClassName = "text-success";
                str = "卖出";
            }

            return this.$createElement("price-label", {
                props: { priceClassName, price: str },
            });

        },

        formatterSignalDealType(value, cloumn) {

            if(!this.isVIP)
            {
                return "***"
            }

            let val = value["deal_type"];
            let str = "";
            let priceClassName;
            if (val == 'enterTrade') {
                priceClassName = "text-danger";
                str = "开仓";
            } else if (val == 'exitTrade') {
                priceClassName = "text-success";
                str = "平仓";
            }

            return this.$createElement("price-label", {
                props: { priceClassName, price: str },
            });

        },

        formatterCurrentVolume(value, cloumn) {
            if(!this.isVIP)
            {
                return "***"
            }
            const l_current_volume = value["l_current_volume"];
            const s_current_volume = value["s_current_volume"];
            // console.log("l_current_volume:", l_current_volume);
            // console.log("s_current_volume:", s_current_volume);
            let currentVolume = 0;
            if(l_current_volume > 0)
            {
                currentVolume = l_current_volume;
            }
            else if(s_current_volume > 0)
            {
                currentVolume = s_current_volume * -1;
            }

            let priceClassName;
            if (currentVolume > 0) {
                priceClassName = "text-danger";
            } else {
                priceClassName = "text-success";
            }

            return this.$createElement("price-label", {
                props: { priceClassName, price: currentVolume.toFixed(0) },
            });

        },
        formatterMarketValue(value, cloumn) {
            const l_current_volume = value["l_current_volume"];
            const s_current_volume = value["s_current_volume"];
            // const str = value[cloumn.property];
            // console.log("l_current_volume:", l_current_volume);
            // console.log("s_current_volume:", s_current_volume);
            let val = 0;
            if(l_current_volume > 0)
            {
                val = parseFloat(value['l_market_value']);
            }
            else if(s_current_volume > 0)
            {
                val = parseFloat(value['s_market_value']);
            }
            // val.toFixed(2).toLocaleString();
            let formattedNumber = numeral(val).format('0,0.00');
            return "¥" + formattedNumber;

        },
        formatterUseMarginAmount(value, cloumn) {
            const l_current_volume = value["l_current_volume"];
            const s_current_volume = value["s_current_volume"];
            // const str = value[cloumn.property];
            // console.log("l_current_volume:", l_current_volume);
            // console.log("s_current_volume:", s_current_volume);
            let val = 0;
            if(l_current_volume > 0)
            {
                val = parseFloat(value['l_use_margin_amount']);
            }
            else if(s_current_volume > 0)
            {
                val = parseFloat(value['s_use_margin_amount']);
            }
            let formattedNumber = numeral(val).format('0,0.00');
            return "¥" + formattedNumber;
        },
        formatterAvgPrice(value, cloumn) {
            if(!this.isVIP)
            {
                return "***"
            }

            const l_current_volume = value["l_current_volume"];
            const s_current_volume = value["s_current_volume"];
            // const str = value[cloumn.property];
            // console.log("l_current_volume:", l_current_volume);
            // console.log("s_current_volume:", s_current_volume);
            let price = 0;
            if(l_current_volume > 0)
            {
                price = parseFloat(value['l_avg_price_o']);
            }
            else if(s_current_volume > 0)
            {
                price = parseFloat(value['s_avg_price_o']);
            }

            let formattedNumber = numeral(price).format('0,0.00');
            return "¥" + formattedNumber;
        
        },
        formatterDateTime(value, cloumn) {
            let date = value[cloumn.property];
            // console.log("---date:",date);
            var m = moment(date);
            return m.format("MM-DD HH:mm");
        },


        // ----
        formatterContract_1(value, cloumn) {
            return this.formatterContract(value, cloumn);
        },
        formatterPriceWinLose_1(value, cloumn) {
            return this.formatterPriceWinLose(value, cloumn);

        },

        formatterSignalWinLose_1(value, cloumn) {

            return this.formatterSignalWinLose(value, cloumn);

        },

        formatterCategory(value, cloumn) {

            const category_name = value["category_name"];
            const name = value["name"];
            return [category_name," ",name].join("")

        },

        formatterSignalBuySell_1(value, cloumn) {

            if(!this.isVIP_1)
            {
                return "***"
            }

            let val = value["buy_sell"];
            let str = "";
            let priceClassName;
            if (val == 'buy') {
                priceClassName = "text-danger";
                str = "买入";
            } else if (val == 'sell') {
                priceClassName = "text-success";
                str = "卖出";
            }

            return this.$createElement("price-label", {
                props: { priceClassName, price: str },
            });

        },

        formatterSignalDealType_1(value, cloumn) {

            if(!this.isVIP_1)
            {
                return "***"
            }

            let val = value["deal_type"];
            let str = "";
            let priceClassName;
            if (val == 'enterTrade') {
                priceClassName = "text-danger";
                str = "开仓";
            } else if (val == 'exitTrade') {
                priceClassName = "text-success";
                str = "平仓";
            }

            return this.$createElement("price-label", {
                props: { priceClassName, price: str },
            });

        },

        formatterCurrentVolume_1(value, cloumn) {
            if(!this.isVIP_1)
            {
                return "***"
            }
            const l_current_volume = value["l_current_volume"];
            const s_current_volume = value["s_current_volume"];
            // console.log("l_current_volume:", l_current_volume);
            // console.log("s_current_volume:", s_current_volume);
            let currentVolume = 0;
            if(l_current_volume > 0)
            {
                currentVolume = l_current_volume;
            }
            else if(s_current_volume > 0)
            {
                currentVolume = s_current_volume * -1;
            }

            let priceClassName;
            if (currentVolume > 0) {
                priceClassName = "text-danger";
            } else {
                priceClassName = "text-success";
            }

            return this.$createElement("price-label", {
                props: { priceClassName, price: currentVolume.toFixed(0) },
            });

        },
        formatterMarketValue_1(value, cloumn) {
            return this.formatterMarketValue(value, cloumn);

        },
        formatterUseMarginAmount_1(value, cloumn) {
            return this.formatterUseMarginAmount(value, cloumn);
        },
        formatterAvgPrice_1(value, cloumn) {
            if(!this.isVIP_1)
            {
                return "***"
            }

            const l_current_volume = value["l_current_volume"];
            const s_current_volume = value["s_current_volume"];
            // const str = value[cloumn.property];
            // console.log("l_current_volume:", l_current_volume);
            // console.log("s_current_volume:", s_current_volume);
            let price = 0;
            if(l_current_volume > 0)
            {
                price = parseFloat(value['l_avg_price_o']);
            }
            else if(s_current_volume > 0)
            {
                price = parseFloat(value['s_avg_price_o']);
            }

            let formattedNumber = numeral(price).format('0,0.00');
            return "¥" + formattedNumber;
        
        },

        //----

      

        selectionChange(selectedRows) {
            this.selectedRows = selectedRows;
        },

        async getLists()
        {
            const category = this.category;
            let fromData = {
                strategy_type:"SwiftStorm",
            }
            if(category && category != undefined && category != "")
            {
                fromData.category = category;
            }
            const res = await futureApi.getStrategy(fromData);
            if (res && res.code == 200) {
                
                const { data } = res;
                this.tableData = data.list;
                this.categoies = data.categoies;
                this.isVIP = data.isVIP;

                this.l_current_volume = data.l_current_volume;
                this.s_current_volume = data.s_current_volume;

                this.l_current_volume_count = data.l_current_volume_count;
                this.s_current_volume_count = data.s_current_volume_count;

                this.float_porfit_o = parseFloat(data.float_porfit_o);
                this.float_porfit_o_str = numeral(data.float_porfit_o).format('0,0.00');
                
                // console.log("---futuresLongShort:",this.futuresLongShort)
            }


            let fromData1 = {
                signal_type:"SwiftStorm",
            }
            if(category && category != undefined && category != "")
            {
                fromData1.category = category;
            }
            const res1 = await futureApi.getSignal(fromData1);
            // console.log("---res1:",res1)
            if (res1 && res1.code == 200) {
                
                const { data } = res1;
                const new_list = data.list;

                if(!new_list || new_list.length <= 0)
                {
                    return;
                }

                this.exit_float_porfit_o = parseFloat(data.exit_float_porfit_o);
                this.exit_float_porfit_o_str = numeral(data.exit_float_porfit_o).format('0,0.00');
                
                this.tableData1 = new_list;
            }
        },

        async getLists1()
        {
            const category = this.category;
            let fromData = {
                strategy_type:"EverSteady",
            }
            if(category && category != undefined && category != "")
            {
                fromData.category = category;
            }
            const res = await futureApi.getStrategy(fromData);
            if (res && res.code == 200) {
                
                const { data } = res;
                this.tableData_1 = data.list;
                // this.categoies = data.categoies;
                this.isVIP_1 = data.isVIP;

                this.l_current_volume_1 = data.l_current_volume;
                this.s_current_volume_1 = data.s_current_volume;
                this.l_current_volume_count_1 = data.l_current_volume_count;
                this.s_current_volume_count_1 = data.s_current_volume_count;
                this.float_porfit_o_1 = parseFloat(data.float_porfit_o);
                this.float_porfit_o_str_1 = numeral(data.float_porfit_o).format('0,0.00');
                
                // console.log("---futuresLongShort:",this.futuresLongShort)
            }


            let fromData1 = {
                signal_type:"EverSteady",
            }
            if(category && category != undefined && category != "")
            {
                fromData1.category = category;
            }
            const res1 = await futureApi.getSignal(fromData1);
            // console.log("---res1:",res1)
            if (res1 && res1.code == 200) {
                
                const { data } = res1;
                const new_list = data.list;

                if(!new_list || new_list.length <= 0)
                {
                    return;
                }

                this.exit_float_porfit_o_1 = parseFloat(data.exit_float_porfit_o);
                this.exit_float_porfit_o_str_1 = numeral(data.exit_float_porfit_o).format('0,0.00');

                
                this.tableData1_1 = new_list;
            }
        },


        async getProfitDaily()
        {
            let fromData = {
                strategy_type:"SwiftStorm",
            }
        
            const res = await futureApi.getProfitDaily(fromData);
            if (res && res.code == 200) {
                const { data } = res;

                let profits = [];
                let labels = [];

                for (let i = 0; i < data.list.length; i++) {
                let item = data.list[i];
                profits.push(item.profit);
                var m = moment(item.date);
                labels.push(m.format("MM-DD"));
                }

                let chartData = {
                datasets: [
                    {
                    label: "盈亏",
                    data: profits,
                    
                    },
                ],
                labels: labels,
                
                };

                this.bigLineChart.chartData = chartData;

            }
        },

        async getProfitDaily1()
        {
            let fromData = {
                strategy_type:"EverSteady",
            }
        
            const res = await futureApi.getProfitDaily(fromData);
            if (res && res.code == 200) {
                const { data } = res;

                let profits = [];
                let labels = [];

                for (let i = 0; i < data.list.length; i++) {
                let item = data.list[i];
                profits.push(item.profit);
                var m = moment(item.date);
                labels.push(m.format("MM-DD"));
                }

                let chartData = {
                datasets: [
                    {
                    label: "盈亏",
                    data: profits,
                    
                    },
                ],
                labels: labels,
                
                };

                this.bigLineChart1.chartData = chartData;

            }
        }


    },
    destroyed() {
        clearInterval(this.timer);
        clearInterval(this.timer1);
    },
    mounted() {
        this.getLists();
        this.getLists1();
        this.getProfitDaily();
        this.getProfitDaily1();

        this.timer = setInterval(this.getLists, 3000);
        this.timer1 = setInterval(this.getLists1, 3000);
    },
  };
</script>
<style></style>
